module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"calendar":"calendar","bookings":"bookings","guests":"guests","locks":"locks","invoices":"invoices","reports":"reports","settings":"settings"},"sl":{"calendar":"koledar","bookings":"rezervacije","guests":"gostje","locks":"kljucavnice","invoices":"racuni","reports":"porocila","settings":"nastavitve"}}')
  delete Component.options._Ctor
}
